export const ALLOWED_GENDERS = ['MALE', 'FEMALE'];
